
export default function ComparacaoPlanos() {
  const recursos = [
    { nome: 'Cartas programadas', valores: ['1', '3', '5', '10', 'Ilimitado', 'Personalizado'] },
    { nome: 'Áudio guiado', valores: [false, true, true, true, true, true] },
    { nome: 'Exercício Ponte ao Futuro', valores: ['Básico', 'Completo', 'Avançado', 'Avançado', 'Avançado', 'Personalizado'] },
    { nome: 'Autoconhecimento profundo', valores: [false, true, true, true, true, true] },
    { nome: 'Linha do tempo de metas', valores: [false, false, true, true, true, true] },
    { nome: 'Reprogramação mental', valores: [false, false, true, true, true, true] },
    { nome: 'Diário digital', valores: [false, false, false, true, true, true] },
    { nome: 'Mudança de identidade', valores: [false, false, false, true, true, true] },
    { nome: 'Planejamento 5 anos', valores: [false, false, false, false, true, true] },
    { nome: 'Mapas de visão guiados', valores: [false, false, false, false, true, true] },
    { nome: 'Acompanhamento exclusivo', valores: [false, false, false, false, false, true] },
    { nome: 'Sessão individual', valores: [false, false, false, false, false, true] },
  ];

  const planosNomes = ['Semente', 'Clareza', 'Direção', 'Identidade', 'Legado', 'Private'];
  const planosPrecos = ['Grátis', 'R$ 97', 'R$ 297', 'R$ 697', 'R$ 1.497', 'R$ 5.000+'];

  return (
    <section className="py-24 bg-luxury-dark relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gold-500/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">Comparação</span>
            <div className="w-12 h-px bg-gold-500/40"></div>
          </div>
          <h2 className="font-['Playfair_Display'] text-4xl text-white mb-4">
            Compare os <span className="text-gold-400 italic">Planos</span>
          </h2>
        </div>

        <div className="bg-white/[0.03] rounded-2xl border border-gold-500/10 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr className="border-b border-gold-500/15">
                  <th className="px-6 py-5 text-left font-['Montserrat'] text-sm text-white/70 font-medium">Recurso</th>
                  {planosNomes.map((nome, i) => (
                    <th key={i} className={`px-4 py-5 text-center font-['Montserrat'] text-sm font-medium ${
                      i === 1 ? 'text-gold-400' : 'text-white/70'
                    }`}>
                      {nome}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gold-500/5">
                {recursos.map((recurso, idx) => (
                  <tr key={idx} className="hover:bg-white/[0.02] transition-colors">
                    <td className="px-6 py-4 font-['Montserrat'] text-sm text-white/50">{recurso.nome}</td>
                    {recurso.valores.map((valor, i) => (
                      <td key={i} className="px-4 py-4 text-center">
                        {typeof valor === 'boolean' ? (
                          valor ? (
                            <i className="ri-check-line text-xl text-gold-400"></i>
                          ) : (
                            <i className="ri-close-line text-xl text-white/15"></i>
                          )
                        ) : (
                          <span className={`font-['Montserrat'] text-sm ${i === 1 ? 'text-gold-400 font-semibold' : 'text-white/50'}`}>
                            {valor}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr className="bg-white/[0.03]">
                  <td className="px-6 py-5 font-['Montserrat'] text-sm font-semibold text-white/70">Investimento</td>
                  {planosPrecos.map((preco, i) => (
                    <td key={i} className={`px-4 py-5 text-center font-['Montserrat'] text-sm font-bold ${
                      i === 1 ? 'text-gold-400' : 'text-white'
                    }`}>
                      {preco}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
